import React from "react";
import LegalLayout from "../components/LegalLayout";

const Section = ({ id, title, children }) => (
  <section id={id}>
    <h2 className="font-serif text-2xl md:text-3xl text-white mb-4">{title}</h2>
    <div className="space-y-3 text-white/75">{children}</div>
  </section>
);

const Cookies = () => (
  <div data-testid="page-cookies">
    <LegalLayout eyebrow="Cookies" title="Cookiepolicy" updated="2026-07-05">
      <p>
        Denna cookiepolicy beskriver hur webbplatsen{" "}
        <strong>orkesteradmin.se</strong> använder cookies och liknande tekniker
        (t.ex. localStorage). Genom att fortsätta använda sidan godkänner du
        användning av nödvändiga cookies. Övriga cookies kan avaktiveras i din
        webbläsare.
      </p>

      <Section id="vad" title="1. Vad är en cookie?">
        <p>
          En cookie är en liten textfil som placeras på din enhet när du besöker
          en webbplats. Den används bland annat för att komma ihåg inställningar
          och för att förbättra användarupplevelsen.
        </p>
      </Section>

      <Section id="vilka" title="2. Vilka cookies använder vi?">
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse" data-testid="cookies-table">
            <thead>
              <tr className="border-b border-white/15 text-left text-white/80">
                <th className="py-3 pr-4 font-medium">Namn</th>
                <th className="py-3 pr-4 font-medium">Syfte</th>
                <th className="py-3 pr-4 font-medium">Typ</th>
                <th className="py-3 font-medium">Livslängd</th>
              </tr>
            </thead>
            <tbody className="text-white/70">
              <tr className="border-b border-white/10">
                <td className="py-3 pr-4">__cf_bm</td>
                <td className="py-3 pr-4">
                  Cloudflare bot-skydd. Krävs för att förhindra automatiserat missbruk.
                </td>
                <td className="py-3 pr-4">Nödvändig</td>
                <td className="py-3">30 min</td>
              </tr>
              <tr className="border-b border-white/10">
                <td className="py-3 pr-4">ph_* (PostHog)</td>
                <td className="py-3 pr-4">
                  Anonym användningsstatistik (t.ex. sidvisningar) för att förbättra sidan.
                </td>
                <td className="py-3 pr-4">Analys</td>
                <td className="py-3">1 år</td>
              </tr>
              <tr>
                <td className="py-3 pr-4">Stripe (vid beställning)</td>
                <td className="py-3 pr-4">
                  Cookies sätts av Stripe när du klickar på "Beställ". Krävs för säker betalning.
                </td>
                <td className="py-3 pr-4">Tredje part</td>
                <td className="py-3">Enligt Stripes policy</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-sm text-white/55">
          Utöver dessa förekommer inga marknadsförings- eller spårningscookies
          från tredje part.
        </p>
      </Section>

      <Section id="hantera" title="3. Hantera cookies">
        <p>Du kan när som helst radera eller blockera cookies via din webbläsare:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <a
              href="https://support.google.com/chrome/answer/95647"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#d4af37] hover:underline"
            >
              Google Chrome
            </a>
          </li>
          <li>
            <a
              href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#d4af37] hover:underline"
            >
              Microsoft Edge
            </a>
          </li>
          <li>
            <a
              href="https://support.mozilla.org/sv/kb/Kakor-information-som-webbplatser-lagrar-p-din-dator"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#d4af37] hover:underline"
            >
              Mozilla Firefox
            </a>
          </li>
          <li>
            <a
              href="https://support.apple.com/sv-se/guide/safari/sfri11471/mac"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#d4af37] hover:underline"
            >
              Apple Safari
            </a>
          </li>
        </ul>
        <p className="text-sm text-white/55">
          Om du väljer att blockera nödvändiga cookies kan vissa funktioner på
          sidan sluta fungera korrekt (t.ex. kontaktformulär eller beställning).
        </p>
      </Section>

      <Section id="andringar" title="4. Ändringar">
        <p>
          Vi kan komma att uppdatera denna cookiepolicy. Den senaste versionen
          publiceras alltid här med datumet för uppdatering.
        </p>
      </Section>

      <Section id="kontakt" title="5. Kontakt">
        <p>
          Har du frågor om cookies eller behandling av dina uppgifter? Läs{" "}
          <a href="/integritet" className="text-[#d4af37] hover:underline">
            Integritetspolicyn
          </a>{" "}
          eller mejla{" "}
          <span className="text-white">kontakt.orkesteradmin@gmail.com</span>.
        </p>
      </Section>
    </LegalLayout>
  </div>
);

export default Cookies;
